import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLang } from "../i18n";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Heart, Languages, LogOut, Shield, Compass } from "lucide-react";

export default function Header() {
  const { lang, setLang, t } = useLang();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-[hsl(var(--background))]/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5">
          <span className="grid h-9 w-9 place-items-center rounded-xl bg-primary text-primary-foreground shadow-md">
            <Heart className="h-5 w-5" fill="currentColor" />
          </span>
          <span className="font-display text-xl font-bold tracking-tight text-primary">core-emotion</span>
        </Link>

        <div className="flex items-center gap-2">
          <button
            data-testid="lang-toggle"
            onClick={() => setLang(lang === "nl" ? "en" : "nl")}
            className="flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-sm font-semibold text-foreground transition-colors hover:bg-secondary"
            aria-label="Language toggle"
          >
            <Languages className="h-4 w-4" />
            {lang.toUpperCase()}
          </button>

          {user ? (
            <>
              {loc.pathname !== "/journey" && (
                <Button data-testid="nav-journey" variant="ghost" size="sm" onClick={() => nav("/journey")}>
                  <Compass className="mr-1.5 h-4 w-4" /> {t("dashboard")}
                </Button>
              )}
              {(user.role === "superadmin" || user.role === "org_admin") && (
                <Button data-testid="nav-admin" variant="ghost" size="sm" onClick={() => nav("/admin")}>
                  <Shield className="mr-1.5 h-4 w-4" /> {t("admin")}
                </Button>
              )}
              <Button data-testid="logout-btn" variant="outline" size="sm" onClick={() => { logout(); nav("/"); }}>
                <LogOut className="mr-1.5 h-4 w-4" /> {t("logout")}
              </Button>
            </>
          ) : (
            loc.pathname !== "/auth" && (
              <Button data-testid="nav-login" size="sm" onClick={() => nav("/auth")}>
                {t("login")}
              </Button>
            )
          )}
        </div>
      </div>
    </header>
  );
}
